export default __webpack_public_path__ + "static/char-41-06697cdada3602e1bba9cebfe4c4bc71.gif";